<template>
	<div>
		<v-card v-if="!external" :to="getUrl()">
			<treatment-card :treatment="treatment"></treatment-card>
		</v-card>

		<v-card v-if="external" :href="getUrl()">
			<treatment-card :treatment="treatment"></treatment-card>
		</v-card>
	</div>
</template>

<script>
import TreatmentCard from './TreatmentCard';
export default {
	components: {
		TreatmentCard
	},
	props: {
		treatment: {},
		external: Boolean,
		url: String
	},
	methods: {
		getUrl() {
			if (this.$props.url) {
				return this.$props.url;
			}
			return `/behandlinger/${this.treatment.url}`;
		}
	}
};
</script>

<style scoped></style>
